import { TextField } from '@mui/material';
import { useRef, useEffect } from 'react';

interface DateEditorProps {
    ruleId: string;
    value: string;
    onChange: (value: string) => void;
}

function DateEditor({ ruleId, value, onChange }: DateEditorProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    // Mettre à jour la valeur initiale si elle change
    useEffect(() => {
        if (inputRef.current && inputRef.current.value !== value) {
            inputRef.current.value = value || '';
        }
    }, [value]);

    return (
        <TextField
            inputRef={inputRef}
            type="date"
            size="small"
            fullWidth
            defaultValue={value || ''}
            onBlur={(e) => onChange(e.target.value)}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
};

export default DateEditor;
